import React, { useRef } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartOptions,
  ChartData,
} from 'chart.js'
import { Bar, getElementAtEvent } from 'react-chartjs-2'
import { brandColors, chartSettings } from '../common/const'

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

interface MinSOCChartProps {
  labels: string[]
  dataSet: number[]
  chartTitle: string
  dataLabel: string
  onClick?: (index: number) => void
}

export const MinSOCChart: React.FC<MinSOCChartProps> = ({ labels, dataSet, chartTitle, dataLabel, onClick }) => {
  const chartRef = useRef()
  const data: ChartData<'bar'> = {
    labels,
    datasets: [
      {
        label: dataLabel,
        data: dataSet,
        backgroundColor: brandColors.warning,
        stack: 'impacts',
        borderWidth: 0,
        borderRadius: 0,
      }
    ],
  }

  const onBarClick = (event: React.MouseEvent<HTMLCanvasElement>) => {
    if (!chartRef.current || !onClick) {
      return
    }
    const elements = getElementAtEvent(chartRef.current, event)
    if (!elements || elements.length == 0) {
      return
    }
    const element = elements[0]
    const index = element.index
    onClick(index)
  }

  return <Bar ref={chartRef} data={data} options={{
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
      },
      title: {
        display: true,
        text: chartTitle,
      },
    },
    scales: {
      x: { stacked: true },
      y: { stacked: true },
    },
  }} {...chartSettings} onClick={onBarClick} />
}
